import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';

export const getModifiedViewProps = viewProps => {
    const strings = getOwaMiniCommonStrings();
    const {
        titleKey,
        subtitleKey,
        primaryBtnTextKey,
        secondaryBtnTextKey,
        tertiaryActionBtnTextKey,
        secondaryBtnIcon,
        primaryButtonArialLabelKey,
        secondaryButtonArialLabelKey,
        tertiaryButtonArialLabelKey,
    } = viewProps;
    return {
        ...(titleKey && { title: strings[titleKey] }),
        ...(subtitleKey && { subtitle: strings[subtitleKey] }),
        ...(primaryBtnTextKey && {
            primaryButtonText: strings[primaryBtnTextKey],
        }),
        ...(secondaryBtnTextKey && {
            secondaryButtonText: strings[secondaryBtnTextKey],
        }),
        ...(tertiaryActionBtnTextKey && {
            tertiaryButtonText: strings[tertiaryActionBtnTextKey],
        }),
        ...(secondaryBtnIcon && {
            // TODO: Remove this check once Fluentisation is rolled out WW and iris campaign config is updated
            secondaryButtonIcon:
                secondaryBtnIcon === 'Settings' ? 'SettingsRegular' : secondaryBtnIcon,
        }),
        ...(primaryButtonArialLabelKey && {
            primaryButtonAriaLabel: strings[primaryButtonArialLabelKey],
        }),
        ...(secondaryButtonArialLabelKey && {
            secondaryButtonAriaLabel: strings[secondaryButtonArialLabelKey],
        }),
        ...(tertiaryButtonArialLabelKey && {
            tertiaryButtonAriaLabel: strings[tertiaryButtonArialLabelKey],
        }),
    };
};
